module.exports = __webpack_public_path__ + "img/54-1ed17c.png";